/**
 * Dispatching while a truck's tracker is silent (ST-00205): the API call the dispatch preview
 * makes for its "tracker silent" warning. Shapes: `types/lexistar-dispatch`. Server:
 * server/modules/lexistar/trips (GET /trips/:id/last-report), mounted at /api/lexistar.
 *
 * Thin wrapper over the shared axios instance in `services/api` (cookie-session auth, CSRF
 * header, single-flight 401 refresh; `api` already carries `/api`). Resolves to the response BODY.
 *
 *   tripLastReport(tripId)  → TripLastReport
 *        when the trip's truck last reported a position, and whether that is older than the
 *        server's threshold (the driver is messaged at dispatch either way; tracking and the
 *        trip's stages start when the tracker next reports)
 */
import api from './api';
import type { TripLastReport } from '../types/lexistar-dispatch';

export type { TripLastReport };

const LX = '/lexistar';

/** The trip's truck's last report (lexistar.trips.view). */
export async function tripLastReport(tripId: string): Promise<TripLastReport> {
  const res = await api.get(`${LX}/trips/${encodeURIComponent(tripId)}/last-report`);
  return res.data as TripLastReport;
}
